import React, { useEffect } from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { Img } from 'react-image';
import classNames from 'classnames';
import { useThemeContext } from 'src/context/ThemeProvider';
import { UserContextProvider, useUserContext } from 'src/context/UserProvider';

interface GuestUserNavbarProps {
	token?: string;
	ForBackToHiringAssessmentId?: string;
}

const GuestUserNavbar: React.FC<GuestUserNavbarProps> = ({ token, ForBackToHiringAssessmentId }) => {
	const { themeMode } = useThemeContext();
	const location = useLocation();
	const navigate = useNavigate();
	const { hiringAssessmentId: paramHiringAssessmentId } = useParams();
	const { hiringAssessmentId, setHiringAssessmentId } = useUserContext();
	// using local storage to store hiringAssessmentId
	// const { hiringAssessmentId, setHiringAssessmentId } = UserContextProvider();
	// const hiringAssessmentId = ForBackToHiringAssessmentId || paramHiringAssessmentId || localStorage.getItem('hiringAssessmentId');

	// useEffect(() => {
	// 	if (hiringAssessmentId) {
	// 		localStorage.setItem('hiringAssessmentId', hiringAssessmentId);
	// 	}
	// }, [hiringAssessmentId]);

	useEffect(() => {
		const id = ForBackToHiringAssessmentId || paramHiringAssessmentId || hiringAssessmentId;
		if (id) {
			setHiringAssessmentId(id);
		}
	}, [ForBackToHiringAssessmentId, paramHiringAssessmentId, hiringAssessmentId, setHiringAssessmentId]);

	const handleAssessmentsClick = () => {
		navigate(`/placed-hiring-assessment/all-assessments?hiringAssessmentId=${hiringAssessmentId}`);
	};
	return (
		<div
			className="nav-mobile-top transition-all bg-white dark:!bg-[#18222D] w-full h-[70px] font-inter fixed xl:px-[80px] px-[4px] z-[41] "
			style={{ boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)' }}
		>
			<div className="flex items-center justify-between cursor-pointer">
				<div className="flex flex-row justify-between w-full px-4">
					<Img
						src={
							themeMode === 'dark'
								? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
								: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
						}
						width="110"
						height="32px"
						alt="LevelUp Logo"
						className="mt-4"
					/>
					{location.pathname === '/placed-hiring-assessment/all-assessments' && (
						<>
							<Link
								to={`/placed-hiring-assessment/${hiringAssessmentId}`}
								className="text-base font-medium text-[#1C1C28] dark:text-[#FFFFFF] hover:text-[#7777E7] mt-4"
							>
								Home
							</Link>
						</>
					)}
					{token && (
						<button
							onClick={handleAssessmentsClick}
							className={classNames(
								'mt-4 text-base text-[#28293D] text-[14px] font-inter font-medium leading-[24px] break-words hover:text-[#7777E7]',
							)}
						>
							Assessments
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default GuestUserNavbar;
